<p-chart type="line" [data]="data" [options]="options" class="h-[30rem]"></p-chart>
